import { render } from "./past-presidents.vue?vue&type=template&id=e1494934&scoped=true"
import script from "./past-presidents.vue?vue&type=script&lang=js"
export * from "./past-presidents.vue?vue&type=script&lang=js"

import "./past-presidents.vue?vue&type=style&index=0&id=e1494934&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1494934"]])

export default __exports__